import React from "react";

const AblumPersonal = () => {
  return <div>AblumPersonal</div>;
};

export default AblumPersonal;
